import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { environment } from 'src/environments/environment';
import { MatPaginator, MatTableDataSource } from '@angular/material';
// import {} from 'src/app';

export interface Campaign {
  campaignName: string;
  creatorName: string;
  location: string;
  source: number;
  paid: boolean;
  startDate: string;
  endDate: string;
  url: string
  id: string
}
// const ELEMENT_DATA: Campaign[] = [
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Hydrogen', paid: false, source: 1.0079, creatorName: 'Honey kumar singh', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'delhi', id: "5ccfd1a64cedfd00062585ab", name: 'Helium', paid: false, source: 4.0026, creatorName: 'He', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Lithium', paid: false, source: 6.941, creatorName: 'Li', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Hydrogen', paid: false, source: 1.0079, creatorName: 'H', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Helium', paid: false, source: 4.0026, creatorName: 'He', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Lithium', paid: false, source: 6.941, creatorName: 'Li', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Hydrogen', paid: false, source: 1.0079, creatorName: 'H', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Helium', paid: false, source: 4.0026, creatorName: 'He', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Lithium', paid: false, source: 6.941, creatorName: 'Li', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Hydrogen', paid: false, source: 1.0079, creatorName: 'H', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Helium', paid: false, source: 4.0026, creatorName: 'He', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
//   { location: 'mumbai', id: "5ccfd1a64cedfd00062585ab", name: 'Lithium', paid: false, source: 6.941, creatorName: 'Li', startDate: '21/05/2019', endDate: '31/05/2019', url: 'http://codingcafetest-stg.bridgelabz.com/?cid=NWNjZmQxYTY0Y2VkZmQwMDA2MjU4NWFi&type=mcq' },
// ];

@Component({
  selector: 'app-view-campaign',
  templateUrl: './view-campaign.component.html',
  styleUrls: ['./view-campaign.component.scss']
})
export class ViewCampaignComponent implements OnInit {

  displayedColumns = ['name', 'location', 'paid', 'source', 'createrName', 'startDate', 'endDate', 'url', 'delete'];

  // dataSource = [];
  listData = [];
  campaignIdToDelete: any;
  dataSource = new MatTableDataSource<Campaign>(this.listData);

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private utilityServices: UtilityService, private campaign: CampaignService) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.getCampaignData();
  }

  getCampaignData() {
    this.campaign.getListData("ONLINE_CAMPAIGN")
      .subscribe(response => {
        console.log(response);
        this.listData = (response as any).data;
        
        for (var i = 0; i < this.listData.length; i++) {
          if (this.listData[i].campaignPurpose == "MCQ_TEST") {
            this.listData[i].url = environment.websiteUrl + "/?cid=" + this.listData[i].campaignShortName + "&type=mcq";
          }
          else if (this.listData[i].campaignPurpose == "REGISTER_ONLY") {
            this.listData[i].url = environment.websiteUrl + "/?cid=" + this.listData[i].campaignShortName + "&type=reg";
          }
          else {
            this.listData[i].url = environment.websiteUrl + "/?cid=" + this.listData[i].campaignShortName + "&type=reg&refType=ref";
          }
        }
        this.dataSource = new MatTableDataSource(this.listData);
        this.dataSource.paginator = this.paginator;
      });
  }

  copyUrl(url) {
    this.utilityServices.copyToClipBoard(url);
    this.utilityServices.openSnackBar("copied to clipboard");
  }

  deleteCampaign(campaignId) {
    this.campaignIdToDelete = campaignId;
    // this.confirmDialog();
    console.log(this.campaignIdToDelete);
  }

  applyFilter(filterValue: any) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
